/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import APIBaseService from "./api.base.service";

const url = "/v1/exchange"

export let exchangeTypeLookup: any = {};

class ExchangeService extends APIBaseService {
    constructor() {
        super();
        this.usePathPrefix(url)
    }

    async list(){
        let result = await this.get('/')

        this.raiseIfBadStatus(result, 200)
        try{
            result.data.forEach((e: any) =>{
                exchangeTypeLookup[e.id] = e.type;
            })
        }catch (e){}
        return result.data;
    }

    async create(data: any) {
        let result = await this.post("/", data, {
            //encrypt: true
        })

        this.raiseIfBadStatus(result, 200)
        return result.data;
    }

    async delete(id: string) {
        let result = await super.delete(id)

        try {
            delete exchangeTypeLookup[id]
        }catch(e){}

        this.raiseIfBadStatus(result, 204)
        return result.data;
    }

    async enable(id: string) {
        let result = await super.put(`${id}/enable`)

        this.raiseIfBadStatus(result, 204)
        return result.data;
    }

    async disable(id: string) {
        let result = await super.put(`${id}/disable`)

        this.raiseIfBadStatus(result, 204)
        return result.data;
    }
}

export {ExchangeService}
